module.exports = __webpack_public_path__ + "img/Q3.ba1b352.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/Q3.png
// module id = 6I+/
// module chunks = 0